<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-11-06 14:58:28
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-24 15:25:41
-->
<template>
  <div>
    <!-- :showEdit="hasBtn('edit-company-timezone-and-language')"
      :show_del="hasBtn('delete-company-timezone-and-language')" -->
    <!-- <mrc_ess_iconGroup style="top: -50px"
                       :is_disabled="readonly"
                       :showEdit="hasBtn('edit-organizaiton-configuration')"
                       :show_del="hasBtn('delete-organization-configuration')"
                       @handleEdit="handleEdit"
                       @handleDel="handleDel"></mrc_ess_iconGroup> -->
    <staffGroup @flag="handleEdit" :readonly="disabled" ref="staffGroup">
    </staffGroup>
  </div>
</template>

<script>
import staffGroup from './staffGroup.vue'
export default {
  components: {
    staffGroup,
  },
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {}
  },
  async created() {},
  mounted() {},
  methods: {
    handleEdit(val) {
      this.$router.push({
        name: 'enterprise',
      })
    },
    handleDel() {},
  },
  computed: {},
  watch: {},
}
</script>

<style scoped></style>
